import { HLog } from "src/core/helpers"
// import ModuleV1Page from "src/core/modules/v1page"
// import ModuleDev from "src/core/modules/dev"
import ModuleFirstSetting from "src/core/modules/firstsetting"
import ModuleIconHiOutline from "src/core/modules/iconHiOutline"
import ModuleSetting from "src/core/modules/setting"
import ModuleSetting2FA from "src/core/modules/setting2fa"
import ModuleRedirectToken from "src/core/modules/redirectToken"
import ModuleDevSimulator from "src/core/modules/dev_simulator"
import ModuleDev from "src/core/modules/dev"
import ModuleCore from "src/core/modules/core"
import ModuleReactGA from "src/modules/reactga"
import ModuleAdminPanel from "src/modules/adminpanel"
import ModuleChromeNotification from "src/modules/chrome_notification"
import ModuleSignalR from "src/modules/signalR"
import ModuleCheckIDLE from "src/modules/check_idle"
// import ModuleV1Page from "src/core/modules/v1page"
import ModuleQLProject from "src/modules/qlproject"
import ModuleAppVFC from "src/modules/app_vfc"
import { HLink, HLocalStorage } from "@macashipo/mlib"
import Lang_en from "../assets/i18n/en.json"
import Lang_vn from "../assets/i18n/vn.json"

import { store } from "src/store/store"
import { logout, updateHeaderTitle } from "src/App/App.actions"
import { fnListConfigApp } from "src/helpers/fnList"
import "src/assets/scss/theme-layout.css"
import { KConfigApp } from "src/helpers/K"
import ModuleAppDemo from "src/modules/app_demo/indes"
import { sendGGNotifyLog } from "src/services/apiWebhookGGChat"

// eslint-disable-next-line
const ModulesExternal = process.env["REACT_APP_MODULES"]

const DFLanguage = process.env["REACT_APP_MODULES"] || "vn"
const AppConfig: IConfigApp = {
  appInfo: {
    title: "VFC Verify Fumigation",
    appName: "adminv5",
    home: "/",
    // GAId: "UA-119777650-2",
    // GooglePlaceApiKey: "AIzaSyBzpjMv2KczEub9Od-uYrB6Skvqslkf3Fg",
    // GooglePlaceApiKey: "AIzaSyBCngEVc4wGqeENChmkZMXL0I3LWZGhSPY", //prj AllianceITSC
    // footer:
    //   '<span><a href="http://allianceitsc.com">AllianceITSC</a>© 2022 </span>',
    // autoRedirectLoginPageNotFound: true,
    verAdmin: "v5",
    defaultTagInputCell: "textarea",
    // serviceWorkersRun: ["/sw-notify.js"],
    // hasSignalR: true,
    // signalRHub: "/NotificationHub",
    // signalRKey: "jkfghweUIT0923klhgfvas65t823fajkwq",
    hasPushNotify: false,
    hasLoginSocialGoogle: false,
    hasForgotPassword: true,
    hasRegisterAccount: false,
    charSplitArray: ",",
    showClearLocalCache: true,
    //// --- check idle
    // hasCheckIdle: true,
    // checkIdleSecond: 30,
    //// --- end check idle
    numberLocale: "it-IT", //en-US:,. it-IT,vi-VI:.,
    // Goong_APIKEY: "0KsekHsHczoT6HZWBVsYK86yZBmtbQmpGjkeq4i8", //show map vfc
    autoRedirectHomePage: true,
    // GGNotifyWebHook:
    //   "https://chat.googleapis.com/v1/spaces/AAAAvEKTVmk/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=_7Sucf66JSiofT_paDvLUQr3NHZNrEVuXjwDPcSQD2k",
    // GoogleClientId:
    //   "261599714010-770nfjc7ot1s4jh799tone21mmj34cjv.apps.googleusercontent.com",
    useIfFrame: false,
  },
  configApi: {
    baseUrl: "http://vfc02api.allianceitsc.com",
    fnLogout: () => {
      // console.warn("logout")
      store.dispatch(logout())
    },
  },
  configI18n: {
    lng: DFLanguage,
    defaultNS: "common",
    resources: {
      en: {
        common: Lang_en,
      },
      vn: {
        common: Lang_vn,
      },
      vi: {
        common: Lang_vn,
      },
    },
  },
  configAuth: {
    afterLogin: () => {
      HLog.logW("afterLogin")
      // HLink.push(fnListConfigApp.getHomeUrl()) //dang bi loi, chua biet vi sao -> chuyen vao page login xu ly
    },
    afterLogout: () => {
      HLocalStorage.removeItem("FirstLoad")
      HLocalStorage.removeItem("SideMenu")
      console.warn("afterLogout")
      // window.location.href = "/"
      // window.open("/", "_self")
      // window.location.reload()
      setTimeout(() => {
        HLink.push("/")
      }, 500) //ko the chay truc tiep, bi loi redux
    },
  },
  fnList: {
    dispatchFromStore(action) {
      store.dispatch(action)
    },
    updateHeaderTitle: title => {
      store.dispatch(updateHeaderTitle(title))
    },
    onAfterInit: function (HConfig) {
      HLog.logW("After init", HConfig)
      window.sendGGNotifyLog = sendGGNotifyLog
    },
    fnGetRequestUIAppConfigFirstSetting: () => {
      let _keys = [KConfigApp.expandIconHideColor, KConfigApp.defaultLanguage]
      let _obj = {}
      for (let k of _keys) {
        if (AppConfig.UIAppConfig[k] != null) {
          _obj[k] = AppConfig.UIAppConfig[k]
        }
      }
      return _obj
    },
  },
  modules: [
    // ModuleCore,
    // ModuleDev,
    // ModuleDevSimulator,
    ModuleFirstSetting,
    // ModuleCategoryScreen,
    // ModuleV1Page,
    // ModuleIconHiOutline,
    // ModuleSetting,
    // ModuleSetting2FA,
    // ModuleRedirectToken,
    // ModuleReactGA,
    // ModuleAdminPanel,
    // ModuleChromeNotification,
    // ModuleSignalR,
    // ModuleAppDemo,
    // ModuleCheckIDLE,
    // ModuleQLProject,
    // ModuleAppVFC,
  ],
  UIAppConfig: {
    numeralFormat: "0,0.[0]",
    numeralFormatMoney: "0,0.[00]",
    isCheckInvalidProjectId: true,
    ignoreNoProjectId: false,
    timeFormat: "HH:mm",
    dateFormat: "DD-MMMYY", //MomentJS
    datetimeFormat: "DD-MMMYY HH:mm", //MomentJS
    dateFPFormat: "d/m/Y",
    datetimeFPFormat: "d/m/Y H:i",
    widthMobile: 1000,
    symbolDecimal: ",",
    symbolThousand: ".",
    expandIconHideColor: "",
    expandBgColor: "#e4e5e6", //#93d4e3
    styleDefaultCell: { padding: "2px" },
    defaultLanguage: DFLanguage,
    hideEffectAddNew: false,
    hideEffectDelete: false,
    hasSettingPage: false,
    hasChangeLanguage: false,
    listLng: [
      {
        code: "en",
        name: "English",
      },
      {
        code: "vn",
        name: "Tiếng Việt",
      },
    ],
  },
}

export default AppConfig
